export default "__VITE_ASSET__w9AgKEVv__"